/* eslint-disable react-hooks/exhaustive-deps */
import {
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";

interface CustomAutocompleteProps {
  time: number;
  values: string[];
  setValue: React.Dispatch<React.SetStateAction<string[]>>;
  name: string;
  label: string;
  placeholder: string;
  data: any[];
}

const CustomAutocomplete = (props: CustomAutocompleteProps) => {
  const theme = useTheme();

  const handleChange = (event: SelectChangeEvent<typeof props.values>) => {
    const {
      target: { value },
    } = event;
    props.setValue(typeof value === "object" ? [...value] : []);
  };

  return (
    <FormControl fullWidth>
      <InputLabel>{props.label}</InputLabel>
      <Select
        multiple
        value={props.values}
        onChange={handleChange}
        input={<OutlinedInput label={props.label} />}
        MenuProps={MenuProps}
        placeholder={props.placeholder}
        fullWidth
      >
        {props.data.map(({ name, _id }: { name: string; _id: string }) => (
          <MenuItem
            key={_id}
            value={_id}
            style={getStyles(name, props.values, theme)}
          >
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const getStyles = (_id: string, arrId: string[], theme: Theme) => {
  return {
    fontWeight:
      arrId.indexOf(_id) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
};

export default CustomAutocomplete;
